import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  styled,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { formattedAmountWithoutAed } from "../../../utils/CommonFunction";
import { statusStyleArray } from "../config";
import { ReactComponent as MwebDhiramIcon } from "../../../assets/svg/MwebDhiramIcon.svg";
import authActions from "../../../redux/reducers/auth/actions";
import { useDispatch } from "react-redux";

const StyledCard = styled(Card)(({ theme }) => ({
  margin: "0 !important",
  borderRadius: "0",
  boxShadow: "none",
  borderBottom: "1px solid #D7D8D9",
}));

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

export default function MobileProposalCards({ details, selectedTab, loading }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { resetProposalDetails } = authActions;
  const [selectedProposals, setSelectedProposals] = useState([]);

  const handleChange2 = (item) => {
    console.log("called", item);
    if (
      item?.status === "ongoing" ||
      item?.status === "in_warranty" ||
      item?.status === "completed" ||
      item?.status === "completed"
    ) {
      navigate(`/project/details/${item?.proposal_id}`);
    } else {
      navigate(`/proposal/details/${item?.proposal_id}`);
    }
  };

  const handleProposalSelect = (proposalId) => {
    setSelectedProposals((prev) =>
      prev.includes(proposalId)
        ? prev.filter((id) => id !== proposalId)
        : [...prev, proposalId]
    );
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 200,
        }}
      >
        <Typography variant="body1" sx={{ color: "#6B7280" }}>
          Loading...
        </Typography>
      </Box>
    );
  }

  if (!details || details.length === 0) {
    return (
      <Typography
        variant="body1"
        sx={{ textAlign: "center", marginTop: 4, color: "#6B7280" }}
      >
        No proposals available
      </Typography>
    );
  }

  return (
    <Box sx={{ padding: "0 2vw" }}>
      {details.map((item) => (
        <StyledCard key={item.id} onClick={() => handleChange2(item)}>
          <CardContent sx={{ padding: "16px" }}>
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#0D0D0E",
                      maxWidth: "60%",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {selectedTab === 1 ? item?.project?.name : item?.name}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#6B7280",
                      marginRight: "8px",
                    }}
                  >
                    {selectedTab === 1
                      ? item?.project?.project_type
                      : item?.project_type}
                  </Typography>
                </Box>
              </Box>

              {selectedTab !== 1 && (
                <Box
                  sx={{
                    display: "flex",
                    gap: "16px",
                    marginBottom: "12px",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Avatar
                      sx={{
                        width: "32px",
                        height: "32px",
                        fontSize: "12px",
                        marginRight: "6px",
                      }}
                      src={item?.user_data?.profile_url}
                    >
                      {item?.user_data?.username?.charAt(0)?.toUpperCase() ||
                        item?.username?.charAt(0)?.toUpperCase() ||
                        "U"}
                    </Avatar>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "0px",
                      }}
                    >
                      <Typography sx={{ fontSize: "12px", color: "#949DAA" }}>
                        Customer
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "13px",
                          fontWeight: "500",
                          color: "#0D0D0E",
                        }}
                      >
                        {item?.user_data?.username || item?.username}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              )}

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "2px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "#949DAA",
                    fontWeight: 500,
                  }}
                >
                  Start/ End Date
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#0D0D0E",
                  }}
                >
                  {selectedTab === 1
                    ? item?.project?.updatedAt
                      ? moment(item?.project?.updatedAt).format("DD MMM, YYYY")
                      : "-"
                    : item?.start_date && item?.end_date
                    ? `${moment(item.start_date).format("DD MMM")} - ${moment(
                        item.end_date
                      ).format("DD MMM, YYYY")}`
                    : item?.start_date
                    ? moment(item.start_date).format("DD MMM, YYYY")
                    : item?.end_date
                    ? moment(item.end_date).format("DD MMM, YYYY")
                    : "-"}
                </Typography>
              </Box>

              {selectedTab !== 1 && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    margin: ".5vh 0",
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        color: "#949DAA",
                        fontWeight: 500,
                      }}
                    >
                      Cost
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#0D0D0E",
                        marginBottom: "4px",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <MwebDhiramIcon /> {formattedAmountWithoutAed(item?.cost)}
                    </Typography>
                  </Box>

                  {/* <Box>
                    <Typography sx={{ fontSize: "12px", color: "#949DAA", fontWeight: 500 }}>
                      Payment Terms
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        color: "#4D6BF6",
                        fontWeight: "500",
                        marginTop: "4px",
                      }}
                    >
                      Open
                    </Typography>
                  </Box> */}
                </Box>
              )}

              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  sx={{
                    width: "15px",
                    height: "15px",
                    borderRadius: "50%",
                    backgroundColor:
                      statusStyleArray.find(
                        (style) =>
                          style.status ===
                          (selectedTab === 1
                            ? item?.project?.status
                            : item?.proposal_status)
                      )?.backgroundColor || "#E5E5E5",
                    marginRight: "6px",
                    border: "3px solid #e5e5e5",
                  }}
                />
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#0D0D0E",
                  }}
                >
                  {getStatusDisplayText(
                    selectedTab === 1
                      ? item?.project?.status
                      : item?.proposal_status
                  )}
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </StyledCard>
      ))}
    </Box>
  );
}
